export class Accordeon{
	init() {
		$('.features-list__header').click(function() {
			$(this).closest('.features-list__item')
					.siblings('.features-list__item')
					.find('.features-list__content')
					.slideUp().siblings('.features-list__header')
					.removeClass('active');

			$(this).toggleClass('active')
					.siblings('.features-list__content')
					.slideToggle();

		});
	}
}